import React from 'react'
import './index.css';
import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import databricks_apache_badge from '../../assets/databricks_apache_badge.png';

export const Certifications = () => {

  const controls = useAnimation();
  useEffect(() => {
    controls.start({ opacity: 1, x: 0 });
  }, [controls]);
  return (
    <motion.div className='Certifications'
      initial={{ opacity: 0, x: -20 }}
      animate={controls}
      transition={{ duration: 1 }}
    >
      <div className="Header">
        Certifications
      </div>
      <div className="Details">
        
        <a id='databricks_apache' href="https://credentials.databricks.com/4ba402ed-c06d-4971-b6ba-ecf219d31087">
          <div className="ImageArea">
            <img src={databricks_apache_badge} alt="" />
          </div>
          <div className="Detail">
            <div className="Header">
              Databricks Certified Associate Developer for Apache Spark 3.0
            </div>
            <div className="Subheader">
              The Databricks Certified Associate Developer for Apache Spark 3.0 certification validates proficiency in developing Spark applications using Databricks Unified Analytics Platform. It assesses skills in Spark fundamentals, DataFrame/Dataset APIs, Spark SQL, and basic Structured Streaming concepts.
            </div>
          </div>
        </a>

        

      </div>
    </motion.div>
  )
}
